import { useContext, useEffect } from 'react';

import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import {
  ColSize,
  ContentSection,
  DatePickerForm,
  Form,
  InputNumberForm,
  RadioForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';


import { StepTwoFormContext } from '../../contexts/StepTwoForm';

import { ValidateForm } from '../../../../../../../../../shared/utils';

import './index.css';
import { QuotationInfoContext } from '../../../../../shared';
import { OPTION_VALIDITY_PERIOD, OPTIONS_BILLING_PERIOD, PERIOD,DECISION_TYPE, OPTION_YES_OR_NOT } from '../../../../../../../../../shared/interfaces';

export const GeneralDataLife = () => {
  const validateForm = new ValidateForm();

  const { loadSaveQuotationState } =
    useContext(QuotationInfoContext);
  const { stepTwoForm, dateFrom, getDateFromLifeObligatory } =
    useContext(StepTwoFormContext);

  useEffect(() => {
    if(!loadSaveQuotationState) {
      const today = dayjs().format('YYYY-MM-DD');
      getDateFromLifeObligatory(today);
    }
  }, [loadSaveQuotationState]);

  const handlerSelectDomesticPersonal = (value: string) => {
    if (value === DECISION_TYPE.YES) {
      stepTwoForm?.setFieldValue('billingPeriod', PERIOD.YEARLY);

      return;
    }

    stepTwoForm?.setFieldValue('billingPeriod', PERIOD.MONTHLY);
  };

  useEffect(() => {
    if (!loadSaveQuotationState && dateFrom) {
      stepTwoForm?.setFieldValue('vigencyDate', dayjs(dateFrom));
    } 
  }, [loadSaveQuotationState, dateFrom]);

  return (
    <Form
      formProps={{
        form: stepTwoForm,
        name: 'general-data-life-form',
        preserve: true,
      }}
    >
      <ContentSection level='h3' title='Datos Generales'>
        <RowSize>
          <ColSize size={25}>
            <InputNumberForm
              formProps={{
                label: 'Cantidad de asegurados (mínimo 1)',
                name: 'quantityInsured',
                rules: validateForm.generateRules({
                  label: 'cantidad de asegurados',
                  rules: ['required', 'range:1:999999'],
                }),
              }}
              inputNumberProps={{
                placeholder: '1',
                controls: {
                  upIcon: <PlusOutlined />,
                  downIcon: <MinusOutlined />,
                },
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <RadioForm
              formProps={{
                initialValue: DECISION_TYPE.NO,
                label: 'Personal doméstico:',
                name: 'personalDomestic',
              }}
              options={OPTION_YES_OR_NOT}
              radioProps={{
                onChange: (e) => handlerSelectDomesticPersonal(e.target.value),
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <SelectForm
              formProps={{
                initialValue: PERIOD.MONTHLY,
                label: 'Período de facturación:',
                name: 'billingPeriod',
                rules: validateForm.generateRules({
                  label: 'período de facturación',
                  rules: ['required'],
                }),
              }}
              selectProps={{
                disabled: true,
                options: OPTIONS_BILLING_PERIOD,
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <SelectForm
              formProps={{
                initialValue: PERIOD.YEARLY,
                label: 'Período de vigencia:',
                name: 'validityPeriod',
                rules: validateForm.generateRules({
                  label: 'período de vigencia',
                  rules: ['required'],
                }),
              }}
              selectProps={{
                disabled: true,
                options: OPTION_VALIDITY_PERIOD,
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <DatePickerForm
              datePickerProps={{
                disabled: true,
              }}
              formProps={{
                label: 'Vigencia desde:',
                name: 'vigencyDate',
                rules: validateForm.generateRules({
                  label: 'vigencia desde',
                  rules: ['required'],
                }),
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>
    </Form>
  );
};
